<div class="card" [ngClass]="[type, style]">
  <div class="right-side">
    <div class="card-head state">
      <h3 class="card-title">{{ spTitle }}</h3>
      <sp-dropdown *ngIf="multiple_actions" icon="arrow-down" [dropDownId]="cardId" [links]="multiple_actions"></sp-dropdown>
      <sp-button
        *ngIf="action"
        size='"small"'
        [icon]="action.icon || 'plastic-glass'"
        dir="rtl"
        [style]="'ghost icon'"
        class="card-header-action"
        [label]="action.title"
        (clickAction)="action.callback(cardId)"
      ></sp-button>
      <sp-button
        *ngIf="expandable"
        size='"small"'
        [icon]="collapsed ? 'add-square-1' : 'remove-square-1'"
        [label]="collapsed ? 'اظهار' : 'اخفاء'"
        dir="rtl"
        [style]="'ghost ghost2 icon'"
        (click)="expandCollapse()"
      ></sp-button>
      <div class="tag-wrapper" *ngIf="tag">
        <sp-tag [style]="'tag-info'">جديد</sp-tag>
      </div>
      <h3 class="side-title" *ngIf="sideTitle">{{ sideTitle }}</h3>
    </div>
    <div class="card-body" *ngIf="!collapsed">
      <ng-content></ng-content>
    </div>
    <div *ngIf="footer" class="card-footer">
      <sp-button
        size='"small"'
        *ngIf="footer.action"
        [style]="'ghost'"
        [label]="footer.action.title"
        (clickAction)="footer.action.callback()"
      ></sp-button>
      <ng-template *ngIf="footer.multiple_actions">
        <sp-button
          *ngFor="let item of footer.multiple_actions"
          [style]="'menu-btn icon'"
          [size]="'small'"
          [label]="item.title"
          [icon]="item.item"
          (clickAction)="item.callback()"
        ></sp-button>
      </ng-template>
    </div>
  </div>
  <div class="left-side">
    <div class="tag-wrapper" *ngIf="sideTag">
      <sp-tag [style]="sideTag.style">{{ sideTag.title }}</sp-tag>
    </div>
    <div>{{ action_title }}</div>
  </div>
</div>
